import { motion, useReducedMotion } from "framer-motion";

// The Nurtured Parent Co. brand motif — a very fine continuous line inspired
// by the unpredictable path between wakefulness and rest. Used sparingly.
export const Thread = ({ className = "", flip = false }) => {
  const reduce = useReducedMotion();
  return (
    <div aria-hidden="true" className={`pointer-events-none ${className}`}>
      <svg
        viewBox="0 0 1200 60"
        fill="none"
        preserveAspectRatio="none"
        className={`w-full h-12 ${flip ? "-scale-y-100" : ""}`}
      >
        <motion.path
          d="M0 32 C 120 32, 180 10, 300 14 C 420 18, 470 50, 600 46 C 730 42, 780 12, 900 16 C 1020 20, 1100 44, 1200 30"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeLinecap="round"
          initial={reduce ? false : { pathLength: 0, opacity: 0 }}
          whileInView={{ pathLength: 1, opacity: 1 }}
          viewport={{ once: true, margin: "-40px" }}
          transition={{ duration: 2.4, ease: "easeInOut" }}
        />
      </svg>
    </div>
  );
};
